let logState = [];

const getLogState = () => logState;

const setLogState = (...log) => {
    logState.push(log);
};

const clearLogState = () => {
    logState = [];
};

export default {setLogState, clearLogState, getLogState};
